import * as React from 'react';
import { Card, CardContent, CardHeading } from '../../Card/Card';
import { ErrorImage } from './DashboardError.styled';
export const DashboardError = () => {
    return (React.createElement(Card, null,
        React.createElement(CardHeading, null, "Error!"),
        React.createElement(CardContent, null,
            React.createElement(ErrorImage, { src: "/assets/error.png" }))));
};
//# sourceMappingURL=DashboardError.js.map